import React from "react";
import Home from "../components/Home";
import ScrollToTopButton from "../components/ScrollToTopButton";
// import ArtistSlider from "../components/Sliders/ArtistSlider";
import Welcome from "../components/Welcome";
import MobileAppSection from "../components/MobileAppSection";
import NewsMedia from "../components/NewsMedia";
import NewsMediaBelow from "../components/NewsMediaBelow";


// =================== BELOW SECTIONS/COMPONENTS HAVE BEEN COMMENTED OUT AND ARE NOT THE PART OF NEW UI DESIGN ================/

// import About from "../components/About";
// import Faq from "../components/Faq";
// import FaqNew from "../components/FaqNew";
// import Team from "../components/Team";
// import AboutArtist from "../components/AboutArtist";
// import Coaches from "../components/Coaches";
// import CoachesOld from "../components/CoachesOld";
// import ProjectSlider from "../components/Sliders/ProjectSlider";
// import CollectionSlider from "../components/Sliders/CollectionSlider";


function LandingPage() {
  return (
    <>
      <Home />
      {/* <div className="flower-overlay"></div> */}
      <Welcome />
      <MobileAppSection />
      {/* <NewsMedia /> */}
      <NewsMediaBelow />
      <ScrollToTopButton />

      {/* <About /> */}
      {/*  COLLECTIONS SLIDER (collections, pets, auras) */}
      {/* <CollectionSlider/> */}
      {/* <Team /> */}
      {/* <ProjectSlider/> */}
      {/* <AboutArtist/> */}
      {/* <Faq /> */}
      {/* <Coaches/> */}
      {/* <FaqNew /> */}
      {/* <CoachesOld/> */}
      {/* <ArtistSlider/> */}

    </>
  );
}

export default LandingPage;
